import React from 'react';

import { PageSegmentLoadStart } from '@confluence/browser-metrics';
import { fg } from '@confluence/feature-gating';
import {
	ExperienceStart,
	SHARE_AND_RESTRICT_BUTTON_LOAD_EXPERIENCE,
} from '@confluence/experience-tracker';

import { SHARE_BUTTON_PAGE_SEGMENT_LOAD } from './perf.config';
export { getClosestAncestorWithViewRestrictions } from './controller/queries/dataToQueriesState';
import type { ShareRestrictAndCopyCoordinatorProps } from './shareAndRestrictButton/ShareRestrictAndCopyCoordinator';
export {
	type ContentType,
	type ContentSubType,
} from './shareAndRestrictButton/ShareRestrictAndCopyCoordinator';
import {
	ShareAndRestrictButtonLoader,
	ShareAndRestrictButtonSSRLoader,
} from './ShareAndRestrictButtonLoader';

export type ShareAndRestrictButtonProps = ShareRestrictAndCopyCoordinatorProps;

export const ShareAndRestrictButton = (props: Omit<ShareAndRestrictButtonProps, 'flags'>) => (
	<>
		<PageSegmentLoadStart
			metric={SHARE_BUTTON_PAGE_SEGMENT_LOAD}
			isCustomStart
			key={props.contentId}
		/>
		<ExperienceStart name={SHARE_AND_RESTRICT_BUTTON_LOAD_EXPERIENCE} />
		{!fg('confluence_frontend_object_header') ? (
			<ShareAndRestrictButtonLoader {...props} />
		) : fg('confluence_frontend_usd_ssr') ? (
			<ShareAndRestrictButtonSSRLoader {...props} />
		) : (
			<ShareAndRestrictButtonLoader {...props} />
		)}
	</>
);
